import { Platform } from 'react-native';
import { useToast } from 'react-native-toast-notifications';

import { AsyncStorage } from '@utils/storage';

const useInvitationHandlers = () => {
  const toast = useToast();

  const handleClearTeamInvitationToken = async () => {
    toast.show('You have successfully joined the team', {
      placement: 'center',
      duration: 3000,
    });
    if (Platform.OS === 'web') {
      window.sessionStorage.setItem('invitation_token', '');
      window.sessionStorage.setItem('link_type', '');
      window.sessionStorage.setItem('type', '');
      window.sessionStorage.setItem('task_or_project_id', '');
      window.sessionStorage.setItem('pending_chat_invitation_token', '');
      window.sessionStorage.setItem('pending_chat_invitation_id', '');
    } else {
      await AsyncStorage.setItem('invitation_token', '');
    }
  };

  const handleOnErrorInvitation = async () => {
    if (Platform.OS === 'web') {
      window.sessionStorage.setItem('invitation_token', '');
      window.sessionStorage.setItem('link_type', '');
      window.sessionStorage.setItem('type', '');
      window.sessionStorage.setItem('task_or_project_id', '');
      window.sessionStorage.setItem('pending_chat_invitation_token', '');
      window.sessionStorage.setItem('pending_chat_invitation_id', '');
    } else {
      await AsyncStorage.setItem('invitation_token', '').then(() => {});
    }
  };

  return {
    handleClearTeamInvitationToken,
    handleOnErrorInvitation,
  };
};

export default useInvitationHandlers;
